import { Accordion, Box, SpacerNew, Text, useWindowDimensions } from '@jfs/ui-new'
import { useState } from 'react'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import { staticStrings } from '../../static/staticStrings'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import { FaqData } from './FaqData'
import { FaqFooter } from './FaqFooter'
import { style } from './style'

const FAQs = () => {
  const [navVisible, setNavVisible] = useState(false)
  const respPadding = usePadding()
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)

  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }

  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )

  const styleMetaData = style(respPadding, isMobile)

  return (
    <Box {...styleMetaData.mainViewWrap}>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar onPress={handleNav} isLightBackground={true} hamBurgerType="secondary" />
      <Box {...styleMetaData.container}>
        <Text fontFamily="jiotype-black" fontSize={isMobile ? 28 : 44} lineHeight={isMobile ? 38 : 66}>
          {staticStrings.frequentlyAsked}
        </Text>
        <SpacerNew size={isMobile ? 40 : 70} />
        <Accordion data={FaqData} isMobile={isMobile} />
      </Box>
      <Box {...styleMetaData.footerBackground}>
        <FaqFooter respPadding={respPadding} isMobile={isMobile} />
      </Box>
    </Box>
  )
}

export { FAQs as default }
